<template>
  <section class="section">
    <div class="glass-container-main animate__animated animate__fadeIn">
      <div class="level mb-6">
        <div class="level-left">
          <div>
            <h1 class="title is-2 has-text-white mb-2">Estadísticas de Votación</h1>
            <p class="subtitle is-6 has-text-grey-lighter">Análisis detallado de participación por ciudad y restaurante</p>
          </div>
        </div>
      </div>

      <!-- Filters Row -->
      <div class="glass-card p-5 mb-6">
        <div class="columns is-vcentered is-multiline">
          <div class="column is-narrow">
            <busqueda-en-fecha @seleccionada="onFechas" />
          </div>
          <div class="column is-narrow">
            <b-field label="Calificación" custom-class="has-text-grey-light">
              <b-select v-model="filtros.calificacion" expanded class="glass-select">
                <option value="">Todas las estrellas</option>
                <option v-for="n in 5" :key="n" :value="6 - n">
                  {{ 6 - n }} estrellas
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-flex is-align-items-end">
            <b-button 
              type="is-success" 
              icon-left="file-excel"
              class="is-rounded glass-btn-success"
              @click="descargarExcel"
            >
              Exportar Excel
            </b-button>
          </div>
        </div>
      </div>

      <!-- Navigation Tabs -->
      <div class="tabs is-toggle is-fullwidth glass-tabs mb-6">
        <ul>
          <li :class="{ 'is-active': modo === 'ciudad' }">
            <a @click="cambiarModo('ciudad')" class="has-text-weight-bold">
              <b-icon icon="map-marker" class="mr-2" />
              Por Ciudad
            </a>
          </li>
          <li :class="{ 'is-active': modo === 'restaurante' }">
            <a @click="cambiarModo('restaurante')" class="has-text-weight-bold">
              <b-icon icon="store" class="mr-2" />
              Por Restaurante
            </a>
          </li>
        </ul>
      </div>

      <!-- Data Table -->
      <div class="glass-table-container">
        <b-table
          :data="datos"
          :paginated="true"
          :per-page="20"
          :current-page.sync="currentPage"
          :pagination-rounded="true"
          hoverable
          class="glass-table"
        >
          <b-table-column field="nombre" label="Nombre / Ubicación" v-slot="p" sortable>
            <div class="is-flex is-align-items-center">
              <b-icon :icon="modo === 'ciudad' ? 'city' : 'silverware'" size="is-small" class="mr-3 has-text-primary" />
              <span class="has-text-white has-text-weight-medium">{{ p.row.nombre }}</span>
            </div>
          </b-table-column>
          
          <b-table-column field="total" label="Total de Votos" v-slot="p" sortable centered>
            <b-tag type="is-info" class="is-large glass-tag">{{ p.row.total }}</b-tag>
          </b-table-column>

          <template #empty>
            <div class="has-text-centered py-6">
              <b-icon icon="database-off" size="is-large" class="has-text-grey-light mb-4" />
              <p class="has-text-grey">No hay datos disponibles para los filtros seleccionados.</p>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import BusquedaEnFecha from "../Extras/BusquedaEnFecha.vue";
import * as XLSX from "xlsx";

export default {
  name: "EstadisticasComponent",
  components: { BusquedaEnFecha },
  data() {
    return {
      datos: [],
      cargando: false,
      modo: "ciudad",
      filtros: {
        fechaInicio: "",
        fechaFin: "",
        calificacion: "",
      },
      currentPage: 1,
    };
  },
  mounted() {
    this.cargarDatos();
    document.title = "Metropolitan - Estadísticas";
  },
  watch: {
    "filtros.calificacion"() {
      this.cargarDatos();
    },
  },
  methods: {
    onFechas(f) {
      if (Array.isArray(f)) {
        this.filtros.fechaInicio = f[0] ? f[0].toISOString().split("T")[0] : "";
        this.filtros.fechaFin = f[1] ? f[1].toISOString().split("T")[0] : "";
        this.cargarDatos();
      }
    },
    cambiarModo(m) {
      this.modo = m;
      this.cargarDatos();
    },
    cargarDatos() {
      this.cargando = true;
      const accion = this.modo === "ciudad" ? "por_ciudad" : "por_restaurante";
      HttpService.registrar("estadisticas.php", {
        accion,
        filtros: this.filtros,
      }).then((res) => {
        this.datos = res || [];
        this.cargando = false;
      }).catch(err => {
        console.error(err);
        this.cargando = false;
      });
    },

    descargarExcel() {
      if (!this.datos.length) return;
      const ws = XLSX.utils.json_to_sheet(this.datos);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Estadísticas");
      XLSX.writeFile(wb, `estadisticas_${this.modo}.xlsx`);
    },
  },
};
</script>

<style scoped>
.glass-container-main {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 80vh;
}

.glass-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.glass-btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  font-weight: 600;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.2);
}

.glass-tabs /deep/ a {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #94a3b8 !important;
}

.glass-tabs /deep/ .is-active a {
  background: #3b82f6 !important;
  border-color: #3b82f6 !important;
  color: white !important;
}

.glass-table /deep/ .table {
  background: transparent !important;
  color: white !important;
}

.glass-table /deep/ .table thead th {
  background: rgba(255, 255, 255, 0.03) !important;
  color: #3b82f6 !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
}

.glass-table /deep/ .table td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
}

.glass-tag {
  background: rgba(59, 130, 246, 0.2) !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
  color: #60a5fa !important;
}

.glass-select /deep/ select {
  background-color: rgba(30, 41, 59, 0.8) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

@media screen and (max-width: 768px) {
  .glass-container-main {
    padding: 20px;
  }
}
</style>
